import { createContext, type ReactNode } from 'react'

import { type CoreStore, type CoreItemCategory } from '@flecto/types'

type PageProviderContextProps = {
  store: CoreStore | null
  itemCategories: CoreItemCategory[]
}

export const PageProviderContext = createContext<PageProviderContextProps>({
  store: null,
  itemCategories: [],
})

type PageProviderProps = {
  children: ReactNode
  state: {
    store: CoreStore
    itemCategories: CoreItemCategory[]
  }
}

export function PageProvider({ state, children }: PageProviderProps) {
  return (
    <PageProviderContext.Provider value={state}>
      {children}
    </PageProviderContext.Provider>
  )
}
